import { NGXAjax } from '../../common/Services/AjaxService.js';
import { resolve, reject } from './util/api-util';

function fetchTags(collectionId) {
  let url = `/api/collection/content/getTags.json`;
  if (!!collectionId) {
    url = `${url}?collectionId=${collectionId}`;
  }
  return NGXAjax.get(url).then(resolve, reject);
}

export { fetchTags };
